import styled from 'styled-components'

export const H2 = styled.h2`
  font-size: 1.125em;
  line-height: 1.25em;
  font-weight: 500;
  color: ${({ theme }) => theme.darkGrey};
`
